// extracted by mini-css-extract-plugin
export var course = "course-module--course--d3663";
export var courseDesc = "course-module--course-desc--21651";
export var courseDescSub = "course-module--course-desc-sub--24710";
export var courseStructure = "course-module--course-structure--66f99";
export var courseStructureName = "course-module--course-structure-name--1f4a7";
export var courseStructureNum = "course-module--course-structure-num--ee160";
export var courseTitle = "course-module--course-title--0d677";
export var course__col = "course-module--course__col--68754";
export var course__colInner = "course-module--course__col-inner--bb95e";